import { Group } from '../../atoms/Group';
import { Title } from '../../atoms/Title';
import { Text } from '../../atoms/Text';
import { Stack } from '../../atoms/Stack';
import type { CoreProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export interface PageHeaderProps extends CoreProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

export function PageHeader({ title, description, actions, testId, view = 'all' }: PageHeaderProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return (
    <Group justify="space-between" align="flex-start" data-testid={testId} mb="md">
      <Stack gap={4}>
        <Title order={2}>{title}</Title>
        {description ? (
          <Text c="dimmed" size="sm">
            {description}
          </Text>
        ) : null}
      </Stack>
      {actions}
    </Group>
  );
}
